import { render, staticRenderFns } from "./DerivacionModalCompletar.vue?vue&type=template&id=46bf967a"
import script from "./DerivacionModalCompletar.vue?vue&type=script&lang=js"
export * from "./DerivacionModalCompletar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports